import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export default function ProductDetail() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const [qty, setQty] = useState(1);
  const { add } = useCart();

  useEffect(() => { api.get(`/products/${id}`).then(r => setP(r.data)); }, [id]);

  if (!p) return <div className="max-w-5xl mx-auto px-6 py-20 text-slate-500">Loading…</div>;

  const onAdd = () => { add(p, qty); toast.success(`${p.name} added`); };

  return (
    <div className="max-w-6xl mx-auto px-6 py-12 grid lg:grid-cols-2 gap-12" data-testid="product-detail-page">
      <div className="aspect-square overflow-hidden card-flat">
        <img src={p.image_url} alt={p.name} className="w-full h-full object-cover" />
      </div>
      <div>
        <Link to="/store" className="text-xs text-slate-500 hover:text-[#002855]">← Back to store</Link>
        <div className="label-eyebrow mt-4">{p.category}</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl text-[#0A192F]">{p.name}</h1>
        <div className="mt-3 font-mono text-xl text-[#0A192F]">${p.price.toFixed(2)}</div>
        <p className="mt-6 text-slate-700 leading-relaxed">{p.description}</p>
        <div className="mt-8 flex items-center gap-3">
          <div className="flex items-center border rounded-md">
            <button onClick={() => setQty(q => Math.max(1, q - 1))} className="px-3 h-11 text-lg" data-testid="qty-dec">−</button>
            <div className="w-10 text-center font-mono" data-testid="qty-value">{qty}</div>
            <button onClick={() => setQty(q => q + 1)} className="px-3 h-11 text-lg" data-testid="qty-inc">+</button>
          </div>
          <Button onClick={onAdd} className="bg-[#002855] hover:bg-[#0A192F] text-white rounded-md h-11 px-6" data-testid="product-add-to-cart">Add to cart</Button>
        </div>
        <div className="mt-10 border-t pt-6 text-sm text-slate-500 space-y-2">
          <div>· Designed for the Presidential Management Fellows Foundation & Association.</div>
          <div>· Proceeds fund mentorship and program convenings.</div>
          <div>· Ships within 5–7 business days.</div>
        </div>
      </div>
    </div>
  );
}
